import { InnerBox } from "@/components/elements/InnerBox";
import { DATE_FORMAT } from "@/constants/datetime";
import { EMPTY_STR } from "@/constants/string";
import { TalentInfoItem } from "@/features/talent/components/talent-detail/TalentInfoItem";
import { TTalentForm } from "@/features/talent/types/talentForm";
import { divider, black, text } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Stack, Box, Typography, Grid, Divider } from "@mui/material";
import dayjs from "dayjs";

type TTalentResidenceStatusInfoProps = {
  defaultValues?: Partial<TTalentForm>;
};

export const TalentResidenceStatusInfo: FCC<TTalentResidenceStatusInfoProps> = ({ defaultValues }) => {
  return (
    <InnerBox mt={4} p={3} showDivider={false} borderColor={divider.high} bordered={true}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box flex={1}>
          <Typography variant="head20Bold" color={black[30]}>
            在留資格情報
          </Typography>
        </Box>
      </Stack>

      <Stack mt={3}>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <TalentInfoItem label="在留資格" value={defaultValues?.residenceStatus?.residenceStatus} />
          </Grid>
          <Grid item xs={6}>
            <TalentInfoItem
              label="在留期限"
              value={
                defaultValues?.periodOfStay && dayjs(defaultValues.periodOfStay).isValid()
                  ? dayjs(defaultValues.periodOfStay).format(DATE_FORMAT)
                  : ""
              }
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack mt={1}>
        <Grid container spacing={3}>
          <Grid item xs={4}>
            <TalentInfoItem
              label="特定技能1号起算日"
              value={
                defaultValues?.specifiedSkillFirstStartDate && dayjs(defaultValues.specifiedSkillFirstStartDate).isValid()
                  ? dayjs(defaultValues.specifiedSkillFirstStartDate).format(DATE_FORMAT)
                  : ""
              }
            />
          </Grid>
          <Grid item xs={4}>
            <TalentInfoItem
              label="ブランク期間（月単位）"
              value={defaultValues?.blankPeriodMonthly ? defaultValues?.blankPeriodMonthly : EMPTY_STR.TEXT}
            />
          </Grid>
          <Grid item xs={4}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="cap12" color={black[70]}>
                特定技能1号残存期間
              </Typography>
            </Box>

            <Box mt={0.5}>
              <Typography variant="body14Semi" color={text.primary}>
                {defaultValues?.specifiedSkillFirstRemainingTerm
                  ? `${defaultValues.specifiedSkillFirstRemainingTermYear}年 ${defaultValues.specifiedSkillFirstRemainingTermMonth}ヶ月`
                  : "0年0ヶ月"}
              </Typography>
            </Box>

            <Divider sx={{ mt: 2 }} />
          </Grid>
        </Grid>
      </Stack>

      <Stack mt={1} id="passport_code_input">
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <TalentInfoItem label="パスポート番号" value={defaultValues?.passportNumber} isShowDivider={false} />
          </Grid>
          <Grid item xs={6}>
            <TalentInfoItem
              label="パスポート期限"
              value={
                defaultValues?.passportExpiryDate && dayjs(defaultValues.passportExpiryDate).isValid()
                  ? dayjs(defaultValues.passportExpiryDate).format(DATE_FORMAT)
                  : ""
              }
              isShowDivider={false}
            />
          </Grid>
        </Grid>
      </Stack>
    </InnerBox>
  );
};
